import { ApolloClient, gql, InMemoryCache } from '@apollo/client'
import { defaultMemoize } from 'reselect'
import { GRAPHQL_URL } from 'graphql/constants'
import { DEVICE_HASH_HEADER } from 'helpers/observableAjaxHelpers'
import { deviceAppStateSelector } from 'selectors/deviceSelector'
import { getStore } from 'store'

export const getGraphQLClient = defaultMemoize(() => {
  const { deviceId } = deviceAppStateSelector(getStore().getState())
  return new ApolloClient({
    uri: GRAPHQL_URL,
    headers: {
      ...deviceId ? { [DEVICE_HASH_HEADER]: deviceId } : {},
    },
    cache: new InMemoryCache(),
  })
})


export const createGQLQuery = <Query, Response, Input = void | undefined>(query: Query) => (variables: Input) => {
  return getGraphQLClient().query<Response, Input>({
    query: gql`${ query }`,
    variables,
  })
}
